import ChatService from "../services/ChatService";
import { apiBody } from "../apiResponse";
import { CHAT_GROUPS_STORE_MAX, capArrayTail, pruneCacheChatMessages, } from "../../helper/chatMemory";
/** Gom request GET /chat/groups/unread-count: tránh spam khi nhiều dispatch liên tiếp / focusin lặp. */
let unreadCountInFlight = null;
let unreadCountLastStartedAt = 0;
const UNREAD_COUNT_MIN_INTERVAL_MS = 1500;
const chat = {
    namespaced: true,
    state: {
        chatGroups: [],
        chatGroupSelected: {},
        dataSocket: {},
        dataReactionEmoji: {},
        modifyMessageSocket: {},
        unCountChatRead: 0,
        cacheChatMessages: {},
        /** Event socket `{ phase, ts }` để watcher luôn bắt được cả disconnect lẫn reconnect. */
        reconnectSocket: { phase: "idle", ts: 0 },
        searchConversation: {},
        dataUserTyping: {},
        dataUserRecall: {},
        /** Tin nhắn soạn sẵn khi mở chat từ biểu mẫu / admin — chưa gửi. */
        composeDraftMessage: null,
        /** Payload socket type `chat_read_receipt` (realtime cập nhật đã xem). */
        readReceiptSocket: null,
    },
    getters: {
        getChatGroups(state) {
            return state.chatGroups;
        },
    },
    mutations: {
        updateChatGroups(state, payload) {
            const list = Array.isArray(payload) ? payload : [];
            state.chatGroups = capArrayTail(list, CHAT_GROUPS_STORE_MAX);
        },
        updateChatGroupSelected(state, payload) {
            state.chatGroupSelected = payload;
        },
        updateDataSocket(state, payload) {
            state.dataSocket = payload;
        },
        updateDataReactionEmoji(state, payload) {
            state.dataReactionEmoji = payload;
        },
        updateUnCountChatRead(state, payload) {
            state.unCountChatRead = payload;
        },
        modifyMessageSocket(state, payload) {
            state.modifyMessageSocket = payload;
        },
        updateCacheChatMessages(state, payload) {
            const touchId = state.chatGroupSelected && state.chatGroupSelected.id;
            state.cacheChatMessages = pruneCacheChatMessages((payload && typeof payload === "object" ? payload : {}), touchId != null ? String(touchId) : null);
        },
        updateReconnectSocket(state, payload) {
            const phase = payload && typeof payload === "object" && payload.phase
                ? String(payload.phase)
                : "sync";
            const ts = payload && typeof payload === "object" && payload.ts
                ? Number(payload.ts)
                : Date.now();
            state.reconnectSocket = { phase, ts };
        },
        updateSearchConvensation(state, payload) {
            state.searchConversation = payload;
        },
        updateDataUserTyping(state, payload) {
            state.dataUserTyping = payload;
        },
        updateDataUserRecall(state, payload) {
            state.dataUserRecall = payload;
        },
        updateReadReceiptSocket(state, payload) {
            state.readReceiptSocket = payload;
        },
        setComposeDraftMessage(state, payload) {
            state.composeDraftMessage = payload;
        },
    },
    actions: {
        getChatGroups({ commit, dispatch }, payload) {
            const params = {
                'page': 1,
                'per_page': 20,
                'status': "ALL" // "ALL"  - "UNREAD"
            };
            return ChatService.getChatGroups(params).then((res) => {
                if (res) {
                    commit("updateChatGroups", apiBody(res).data);
                }
            });
        },
        getUnreadGroupChat({ commit, dispatch }, payload) {
            if (unreadCountInFlight) {
                return unreadCountInFlight;
            }
            const now = Date.now();
            if (now - unreadCountLastStartedAt < UNREAD_COUNT_MIN_INTERVAL_MS) {
                return Promise.resolve();
            }
            unreadCountLastStartedAt = now;
            unreadCountInFlight = ChatService.getUnreadGroupChat()
                .then((res) => {
                const b = apiBody(res);
                if (b.status) {
                    commit("updateUnCountChatRead", b.data);
                }
            })
                .finally(() => {
                unreadCountInFlight = null;
            });
            return unreadCountInFlight;
        },
        dataSocket({ commit, dispatch }, payload) {
            commit("updateDataSocket", payload);
        },
        dataReactionEmoji({ commit, dispatch }, payload) {
            commit("updateDataReactionEmoji", payload);
        },
        modifyMessageSocket({ commit, dispatch }, payload) {
            commit("modifyMessageSocket", payload);
        },
        dataUserTyping({ commit, dispatch }, payload) {
            commit("updateDataUserTyping", payload);
        },
        dataUserRecall({ commit, dispatch }, payload) {
            commit("updateDataUserRecall", payload);
        },
        readReceiptSocket({ commit }, payload) {
            commit("updateReadReceiptSocket", { ...payload, _ts: Date.now() });
        },
    }
};
export default chat;
